/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum BillingMetricType {
    margin_savings = 'margin_savings',
    native_cost = 'native_cost',
    rate = 'rate',
    system_cost = 'system_cost',
    true_cost = 'true_cost',
    usage = 'usage'
}
